import * as React from "react";
import glamorous from "glamorous";
import { Container, Segment, Button } from "semantic-ui-react";

import { Link as RRLink } from "react-router-dom";
import { auth } from "../../firebase";
import { WithUser, WithUserProps } from "../../helpers/UserDataProvider";

export interface FooterProps extends WithUserProps {}

const FooterContent = glamorous.div({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	width: "100%"
});

const Link = glamorous(RRLink)({
	marginRight: 24
});

const Footer: React.SFC<FooterProps> = props => (
	<Segment inverted vertical>
		<Container>
			<FooterContent>
				<div>
					{props.user.isAuthed && (
						<a
							// inverted
							style={{ cursor: "pointer", marginRight: 24 }}
							onClick={() => {
								auth.signOut();
								window.scrollTo(0, 0);
								window.location.reload();
							}}
						>
							Sign out
						</a>
					)}
					<Link to="/privacy">Privacy Policy</Link>
					<a
						style={{ marginRight: 24 }}
						href="mailto:cathmferrara@iinet.net.au"
					>
						Contact Us
					</a>
				</div>
				<p> Catherine Ferrara &copy; - 2018 </p>
			</FooterContent>
		</Container>
	</Segment>
);

export default WithUser(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx